import { Component } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { map, Observable, takeUntil } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { DocViewerSettingsDialogComponent } from '../dialogs/doc-viewer-settings-dialog/doc-viewer-settings-dialog.component';
import { Store } from '@ngrx/store';
import { currentDocumentView } from '@store/doc-viewer/document-view/document-view.selectors';
import { UserConfigsService } from '@services/user-configs.service';
import { Role } from '@models/role.model';

@Component({
    selector: 'lex-doc-viewer-right-panel',
    templateUrl: './doc-viewer-right-panel.component.html',
    styleUrls: ['./doc-viewer-right-panel.component.scss'],
    standalone: false
})
export class DocViewerRightPanelComponent extends BaseComponent {
	public currentTab$: Observable<"coding" | "details" | "editor"> = this.route.queryParams.pipe(map(x => x.panel as 'coding' | 'details' | 'editor' || 'coding'));

	private lastTab: "coding" | "details" | "editor" = 'coding';

	constructor(
		private store: Store,
		private route: ActivatedRoute,
		private router: Router,
		private matDialog: MatDialog,
		private userConfigsService: UserConfigsService
	) {
		super();

		this.store.select(currentDocumentView()).pipe(
			map((view) => {
				let tempTab = this.lastTab;
				if (this.userConfigsService.inRoles(Role.LimitedFeatureSet))
					tempTab = 'details';
				else if (view === 'redacted' || view === 'annotated')
					tempTab = 'editor';
				this.go(tempTab)
			}),
			takeUntil(this.destroy$)
		).subscribe()
	}

	public go(t: 'coding' | 'details' | 'editor') {
		if (t !== 'editor')
			this.lastTab = t;
		this.router.navigate(["."], {
			queryParams: {
				panel: t
			},
			queryParamsHandling: "merge",
			relativeTo: this.route
		});
	}

	public displaySettingsDialog(): void {
		this.matDialog.open(DocViewerSettingsDialogComponent);
	}
}
